module.exports = __webpack_public_path__ + "static/lesson_4-732c06632ae521d3a754bac993b0ed44.png";